import { createContext } from "react";

export const UserContext = createContext(null);

export const UserHierarchyContext = createContext({ socket: null });